import React from 'react';
import { Subject } from '@material-ui/icons';
import { FormConfigTextField } from '../../config/FormConfigTextField';
import { FormTextField } from '../../fields/FormTextField';
export const FormTextFieldPlugin = {
    icon: React.createElement(Subject, null),
    name: 'Text (free form)',
    type: 'TextField',
    dataTypes: ['text'],
    configurator: FormConfigTextField,
    element: FormTextField
};
//# sourceMappingURL=FormTextFieldPlugin.js.map